import { t } from '@trimble/i18n';
import { Component, Show } from 'solid-js';

interface NameInputProps {
  name: string;
  onNameChange(name: string): void;
  showDefaultChip?: boolean;
}

export const NameInput: Component<NameInputProps> = (props) => {
  function handleInput(e: Event): void {
    props.onNameChange((e.target as HTMLInputElement).value);
  }

  return (
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium text-gray-8" for="palette-name-input">
        {t('measurements.volumetric.gradient.name')}
      </label>
      <div class="relative">
        <input
          id="palette-name-input"
          class={`border border-gray-300 rounded-md px-2 py-1.5 text-sm w-full${
            props.showDefaultChip ? ' pr-20' : ''
          }`}
          type="text"
          value={props.name}
          onInput={handleInput}
          data-testid="edit-palette-name"
        />
        <Show when={props.showDefaultChip}>
          <modus-chip
            class="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"
            chip-style="solid"
            size="small"
            data-testid="edit-palette-default-chip"
            prop:value={t('measurements.volumetric.gradient.defaultChip')}
          />
        </Show>
      </div>
    </div>
  );
};
